const SLIDE_WIDTH = 295;
const SLIDE_OFFSET = 10;

export { SLIDE_WIDTH, SLIDE_OFFSET };
